module.exports = __webpack_public_path__ + "static/media/30.716e909b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/30.svg
// module id = 151
// module chunks = 0